import { render, staticRenderFns } from "./QuestionForm.vue?vue&type=template&id=97277394&scoped=true"
import script from "./QuestionForm.vue?vue&type=script&lang=js"
export * from "./QuestionForm.vue?vue&type=script&lang=js"
import style0 from "./QuestionForm.vue?vue&type=style&index=0&id=97277394&prod&lang=scss&scoped=true"
import style1 from "./QuestionForm.vue?vue&type=style&index=1&id=97277394&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97277394",
  null
  
)

export default component.exports